import React, { useEffect, useState } from 'react'
import Proxies from '../../components/proxies'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup } from 'reactstrap'
import moment from 'moment'

const TaxCampaignHighlightList = () => {
  const [taxCampaignHighlights, setTaxCampaignHighlights] = useState([])
  const [loading, setLoading] = useState(false)
  const [taxCampaignHighlight, setTaxCampaignHighlight] = useState('active')

  useEffect(() => {
    setLoading(true)
    getTaxCampaignHighlihghts()
  }, [])

  function getTaxCampaignHighlihghts() {
    Proxies.GET('TaxCampaignHighlights/pool').then(responseJSON => {
      if (!responseJSON.error) {
        setTaxCampaignHighlights(responseJSON)
      }
      setLoading(false)
    })
  }

  function RemoveTaxCampaignHighlight(TaxCampaignHighlightID) {
    Proxies.POST('TaxCampaignHighlights/removeTaxCampaignHighlight', { TaxCampaignHighlightID }).then(responseJSON => {
      if (!responseJSON.error) {
        getTaxCampaignHighlihghts()
      }
    })
  }

  return (
    <CollapsibleCard
      startOpen
      header={
        <strong>
          Højdepunkter i skattekampagnen
          <Button tag={Link} to={'tax-campaign-highlight/new'} style={{ marginLeft: '16px' }}>
            Opret ny
          </Button>
          <ButtonGroup className='float-right'>
            <Button
              outline
              color='success'
              onClick={() => setTaxCampaignHighlight(taxCampaignHighlight === 'active' ? 'both' : 'active')}
              active={taxCampaignHighlight === 'active'}
            >
              Active
            </Button>
            <Button
              outline
              color='danger'
              onClick={() => setTaxCampaignHighlight(taxCampaignHighlight === 'inactive' ? 'both' : 'inactive')}
              active={taxCampaignHighlight === 'inactive'}
            >
              In-Active
            </Button>
          </ButtonGroup>
        </strong>
      }
    >
      {loading ? (
        <FontAwesomeIcon icon='spinner' spin />
      ) : (
        <DynamicTable
          responsive
          size='sm'
          options={{
            startSort: {
              dir: 'DESC',
              column: 'name'
            },
            fieldFunctions: {
              endDate: e => {
                return moment(e.endDate).format('DD-MM-YYYY')
              },
              brands: e => {
                return e.brands.map(b => b.brandName).join(', ')
              }
            },
            addField: e => {
              return (
                <td>
                  <ButtonGroup>
                    <Button tag={Link} to={'/tax-campaign-highlight/' + e.TaxCampaignHighlightID} id={'edit' + e.TaxCampaignHighlightID}>
                      <FontAwesomeIcon icon='edit' />
                    </Button>
                    <Button
                      id={'delete' + e.TaxCampaignHighlightID}
                      color='danger'
                      onClick={() => {
                        if (confirm('Are you sure you want to delete?')) {
                          RemoveTaxCampaignHighlight(e.TaxCampaignHighlightID)
                        }
                      }}
                    >
                      <FontAwesomeIcon icon='trash' />
                    </Button>
                  </ButtonGroup>
                </td>
              )
            }
          }}
          headers={{
            TaxCampaignHighlightID: '#',
            title: 'Title',
            description: 'Beskrivelse',
            brands: 'Brands'
          }}
          data={
            taxCampaignHighlights && taxCampaignHighlight !== 'both' && !!taxCampaignHighlights.length
              ? taxCampaignHighlights.filter(taxCampaignHighlight => taxCampaignHighlight.removed === (taxCampaignHighlight === 'inactive' ? 1 : 0))
              : taxCampaignHighlights
          }
        />
      )}
    </CollapsibleCard>
  )
}

export default TaxCampaignHighlightList
